import { render, staticRenderFns } from "./TrainingSessionStatusChipCpt.vue?vue&type=template&id=38497ab8&scoped=true&"
import script from "./TrainingSessionStatusChipCpt.vue?vue&type=script&lang=ts&"
export * from "./TrainingSessionStatusChipCpt.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingSessionStatusChipCpt.vue?vue&type=style&index=0&id=38497ab8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38497ab8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
